'use client';

import { useMemo } from 'react';
import type { TaxonomyOption, TaxonomyTerm } from '../../model/product/taxonomy';
import { useProductService } from './useProductService';

export const useSkinType = () => {
  const { useGetSuspenseProductTaxonomy } = useProductService();
  const { data: taxonomy } = useGetSuspenseProductTaxonomy();

  return useMemo(() => {
    const defaultOption: TaxonomyOption = { label: 'All types', value: 'all' };

    if (!taxonomy?.skinType || taxonomy.skinType.length === 0) {
      return [defaultOption];
    }

    return [
      defaultOption,
      ...taxonomy.skinType.map((type: TaxonomyTerm) => ({
        label: type.name,
        value: type.slug,
      })),
    ];
  }, [taxonomy]);
};
